export function actionName(storeName: string, actionDescription: string): string {
  return `[${storeName}] ${actionDescription}`;
}
